import { List } from 'immutable';
import UserMessage from 'records/UserMessage';
import BaseList from 'records/BaseList';

import {
  USER_MESSAGES_ADD,
  USER_MESSAGES_REMOVE_INDEX,
  USER_MESSAGES_REMOVE_ALL,
} from 'actions/userMessages';

const initialState = new BaseList({
  loading: false,
  errorMessage: null,
  data: new List(),
});

const actionsMap = {
  [USER_MESSAGES_ADD]: (state, action) => {
    const messages = UserMessage.addMessage(state.data, action.data);
    return state.merge({
      data: messages,
    });
  },
  [USER_MESSAGES_REMOVE_INDEX]: (state, action) => {
    const messages = UserMessage.removeMessage(state.data, action.data);
    return state.merge({
      data: messages,
    });
  },
  [USER_MESSAGES_REMOVE_ALL]: (state) => {
    return state.merge({
      data: new List(),
    });
  },
};

export default function userMessages(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
